import React from 'react';

import { Card, Col, Row, Statistic, Typography } from 'antd';

import { AgroReportPrevYear, AgroReportSummary } from '../../../models/AgroReport';

const { Text } = Typography;

interface Props {
    current: AgroReportSummary;
    prev: AgroReportPrevYear;
}

const diff = (cur?: number, prv?: number) => {
    if (cur === undefined || prv === undefined) return null;
    const d = cur - prv;
    const sign = d > 0 ? '+' : '';
    return `${sign}${d.toFixed(1)}`;
};

export default function PrevYearCompare(props: Props) {
    const c = props.current;
    const p = props.prev;

    return (
        <Card title="Сравнение с прошлым годом" style={{ marginBottom: 16 }}>
            <Row gutter={16}>
                <Col span={8}>
                    <Statistic
                        title="Урожайность, ц/га"
                        value={p.yield !== undefined ? p.yield : '—'}
                        precision={1}
                        suffix={
                            <Text type={diff(c.yield, p.yield)?.startsWith('-') ? 'danger' : 'success'}>
                                {diff(c.yield, p.yield)}
                            </Text>
                        }
                    />
                </Col>
                <Col span={8}>
                    <Statistic
                        title="САТ10"
                        value={p.sat !== undefined ? p.sat : '—'}
                        precision={0}
                        suffix={
                            <Text type={diff(c.sat10, p.sat)?.startsWith('-') ? 'danger' : 'success'}>
                                {diff(c.sat10, p.sat)}
                            </Text>
                        }
                    />
                </Col>
                <Col span={8}>
                    <Statistic
                        title="ГТК"
                        value={p.gtk !== undefined ? p.gtk : '—'}
                        precision={2}
                        suffix={
                            <Text type={diff(c.gtk, p.gtk)?.startsWith('-') ? 'danger' : 'success'}>
                                {diff(c.gtk, p.gtk)}
                            </Text>
                        }
                    />
                </Col>
            </Row>
        </Card>
    );
}
